export const FIELDS = {
  Administrator: ['name', 'phone', 'photo_data_uri'],
  Pastor: ['email', 'name', 'type', 'department', 'phone', 'photo_data_uri'],
  SeniorPastor: ['email', 'name', 'type', 'department', 'phone', 'photo_data_uri'],
  Evangelist: ['email', 'name', 'type', 'phone', 'photo_data_uri']
};

export const ROLES = {
  Pastor: 'Pastor',
  SeniorPastor: 'Senior Pastor',
  Evangelist: 'Evangelist'
};



// WEBPACK FOOTER //
// ./src/components/pages/profile/constants.js